<template>
  <div>
    <div class="banner-carousel" overlay="linear-gradient(90deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.6) 60%, rgba(0,0,0,0.6) 100%)">
      <div class="carousel-track" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
        <div v-for="(banner, index) in banners" :key="index" class="carousel-slide" indicator-position="outside">
          <img :src="banner.url" alt="banner" style="filter: brightness(30%)" />

          <section style="background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(banner.url)"></section>

          <div class="banner-text cuadrado">
            <el-row :gutter="20"
              ><el-col :span="24"><h2 v-html="$t(banner.valor)"></h2></el-col><el-col :span="24"> <p class="" v-html="$t(banner.texto)"></p> </el-col
            ></el-row>
          </div>
          <!-- <div class="banner-text cuadrado">
            <p v-html="$t(banner.texto)"></p>
          </div> -->

          <!-- <div class="contenedor-externo">
            <div class="card">
              <h2 v-html="$t(banner.valor)"></h2>
              <p v-html="$t(banner.texto)"></p>
            </div>
          </div> -->
        </div>
      </div>

      <!-- Controles -->
      <button class="prev" @click="prevSlide">‹</button>
      <button class="next" @click="nextSlide">›</button>

      <!-- Indicadores -->
      <!-- <div class="indicators">
        <span v-for="(banner, i) in banners" :key="i" :class="{ active: i === currentIndex }" @click="goToSlide(i)"></span>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: 0,
      autoplayInterval: null,
      banners: [
        {
          url: require('@/assets/fotos/03.jpg'),
          valor: 'slides_1.title',
          texto: 'slides_1.texto',
        },
        {
          url: require('@/assets/fotos/04.jpg'),
          valor: 'slides_2.title',
          texto: 'slides_2.texto',
        },
        {
          url: require('@/assets/fotos/05.jpg'),
          valor: 'slides_3.title',
          texto: 'slides_3.texto',
        },
        {
          url: require('@/assets/fotos/06.jpg'),
          valor: 'slides_4.title',
          texto: 'slides_4.texto',
        },
      ],
    }
  },
  mounted() {
    this.autoplayInterval = setInterval(this.nextSlide, 50000)
  },
  beforeDestroy() {
    clearInterval(this.autoplayInterval)
  },
  methods: {
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.banners.length
    },
    prevSlide() {
      this.currentIndex = (this.currentIndex - 1 + this.banners.length) % this.banners.length
    },
    goToSlide(index) {
      this.currentIndex = index
    },
  },
}
</script>
<style>
.cuadrado {
  display: grid;
  place-items: center;
}
.contenedor-externo {
  width: 100%;
  max-width: 360px; /* tamaño del viewport que querés probar */
  margin: 0 auto; /* centra horizontal */
  display: flex;
  justify-content: center;
  align-items: center; /* centra vertical */
  min-height: 100vh; /* ocupa toda la pantalla */
  padding: 16px; /* margen de seguridad */
  box-sizing: border-box;
}
.card {
  width: 100%;
  max-width: 320px; /* para que entre con margen en 360px */
  background: rgba(0, 0, 0, 0.4);
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  text-align: center;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>
<style scoped>
.el-card__body {
  padding: 0px !;
}
.banner-carousel {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 80vh;
  /* height: 100%; */
}

.carousel-track {
  display: flex;
  transition: transform 0.8s ease-in-out;
  height: 100%;
}

.carousel-slide {
  position: relative;
  min-width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.carousel-slide::before {
  content: '';
  position: absolute;
  inset: 0;
  /* background-image: linear-gradient(90deg, rgba(28, 28, 28, 0.6) 0%, rgba(0, 0, 0, 0) 100%); */
  /* background-color: #00000082; */
  z-index: 1;
}
.carousel-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 🔹 Texto centrado sobre cada imagen */
.banner-text {
  /* width: 50%; Ancho fijo del cuadro */
  overflow: hidden; /* Oculta el texto que no cabe */
  text-overflow: ellipsis; /* Muestra puntos suspensivos */
  white-space: nowrap; /* Evita que el texto se ajuste en varias líneas */
  height: 50vh;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffff;
  text-align: center;
  /* text-shadow: 0 2px 10px #ffff; */
  padding: 1rem 1rem;
  /* background: #00000087; */
  /* border-radius: 12px; */
  max-width: 100%;
  font-family: 'roboto-black';
  /* border: 1px solid; */

  border: 0.5px solid #ffffff5d;
  padding: auto;
}

.banner-text h2 {
  /* font-size: 2rem; */
  font-size: 45px;
  margin: 0;
  text-overflow: ellipsis; /* Muestra puntos suspensivos */
  white-space: nowrap; /* Evita que el texto se ajuste en varias líneas */
  font-family: 'roboto-black';
  letter-spacing: 1px;
}

.banner-text p {
  /* font-size: 1.51rem; */
  font-size: 27px;
  color: white;
  margin-top: 10px;
  font-family: 'roboto-regular';
  line-height: 35px;
  text-overflow: ellipsis; /* Muestra puntos suspensivos */
  white-space: break-spaces;
}

/* Botones de navegación */
button.prev,
button.next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.3);
  border: none;
  color: #fff;
  font-size: 1rem;
  padding: 8px 16px;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.3s;
  z-index: 5;
}

button.prev:hover,
button.next:hover {
  background: rgba(0, 0, 0, 0.6);
}

button.prev {
  left: 20px;
}

button.next {
  right: 20px;
}

/* Indicadores */
.indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
  z-index: 5;
}

.indicators span {
  width: 10px;
  height: 10px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.3s;
}

.indicators span.active {
  background: white;
}
@media (min-width: 2561px) {
  .banner-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    /* height: 40%; */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #ffff;
    text-align: center;
    /* text-shadow: 0 2px 10px #ffff; */
    padding: 1rem 1rem;
    /* background: #00000087; */
    /* border-radius: 12px; */
    max-width: 100%;
    font-family: 'roboto-black';
    /* border: 1px solid; */
    border: 0.5px solid #ffffff5d;
    padding: 5%;
    width: 50%;
  }
  .banner-carousel {
    height: 100vh;
  }
  .banner-text h2 {
    font-size: 50px;
  }
  .banner-text p {
    font-size: 30px;
    color: white;
    margin-top: 10px;
    font-family: 'roboto-regular';
    line-height: 40px;
    text-overflow: ellipsis; /* Muestra puntos suspensivos */
    white-space: break-spaces;
  }
}
@media screen and (min-width: 1920px) and (max-width: 2560px) {
  .banner-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    /* height: 40%; */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #ffff;
    text-align: center;
    /* text-shadow: 0 2px 10px #ffff; */
    padding: 1rem 1rem;
    /* background: #00000087; */
    /* border-radius: 12px; */
    max-width: 100%;
    font-family: 'roboto-black';
    /* border: 1px solid; */
    border: 0.5px solid #ffffff5d;
    padding: 5%;
    width: 50%;
  }
  .banner-carousel {
    height: 100vh;
  }
  .banner-text h2 {
    font-size: 45px;
  }
  .banner-text p {
    font-size: 22px;
    color: white;
    margin-top: 10px;
    font-family: 'roboto-regular';
    line-height: 40px;
    text-overflow: ellipsis; /* Muestra puntos suspensivos */
    white-space: break-spaces;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .banner-text {
    /* height: 245px; */
    padding: 5%;
    width: 50%;
  }
  .banner-text h2 {
    font-size: 43px;
  }
  .banner-text p {
    font-size: 22px;
    color: white;
    margin-top: 10px;
    font-family: 'roboto-regular';
    line-height: 40px;
    text-overflow: ellipsis; /* Muestra puntos suspensivos */
    white-space: break-spaces;
  }
  .banner-carousel {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 80vh;
    /* height: 100%; */
  }
}
@media screen and (min-width: 1023px) and (max-width: 1439px) {
  .banner-text {
    /* height: 245px; */
    padding: 4% 10%;
  }
  .banner-text h2 {
    font-size: 38px;
  }
  .banner-text p {
    font-size: 19px;
    color: white;
    margin-top: 10px;
    font-family: 'roboto-regular';
    line-height: 30px;
    text-overflow: ellipsis; /* Muestra puntos suspensivos */
    white-space: break-spaces;
  }
}
/* HORIZONTAL */
@media (orientation: landscape) and (max-height: 500px) {
  .banner-text {
    width: 70%;
  }
  .banner-text h2 {
    font-size: 30px;
  }
  .banner-text p {
    font-size: 19px;
  }
}
@media (orientation: portrait) {
  @media screen and (min-width: 833px) and (max-width: 1024px) {
    .banner-text h2 {
      font-size: 40px;
    }
    .banner-text p {
      font-size: 24px;
      color: white;
      margin-top: 10px;
      font-family: 'roboto-regular';
      line-height: 35px;
      text-overflow: ellipsis; /* Muestra puntos suspensivos */
      white-space: break-spaces;
    }
    .contenido-centrado img {
      width: 70px; /* Ajustá el tamaño según tu diseño */
      height: auto;
    }
  }
  @media screen and (min-width: 375px) and (max-width: 832px) {
    /* .carousel-track {
    display: flex;
    transition: transform 0.8s ease-in-out;
    height: 80%;
  } */
    .banner-text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: break-spaces !important;
      /* height: 40%; */
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #ffff;
      text-align: center;
      /* text-shadow: 0 2px 10px #ffff; */
      padding: 18%;
      /* background: #00000087; */
      /* border-radius: 12px; */
      max-width: 60%;
      font-family: 'roboto-black';
      /* border: 1px solid; */
      border: 0.3px solid #ffffff5d;
      /* padding: 5%; */
      /* width: 55%; */
      width: 85%;
      /* width: 100%; */
      max-width: 360px;
      margin: 0 auto;
      /* display: flex; */
      justify-content: center;
      /* align-items: center; */
      /* min-height: 100vh; */
      padding: 16px;
      box-sizing: border-;
    }
    .banner-text h2 {
      font-size: 30px;
      white-space: break-spaces;
    }
    .banner-text p {
      font-size: 18px;
      color: white;
      margin-top: 10px;
      font-family: 'roboto-regular';
      line-height: 30px;
      text-overflow: ellipsis; /* Muestra puntos suspensivos */
      white-space: break-spaces;
    }
    .contenido-centrado img {
      width: 80px; /* Ajustá el tamaño según tu diseño */
      height: auto;
    }
  }
  @media (max-width: 375px) {
    .carousel-track {
      display: flex;
      transition: transform 0.8s ease-in-out;
      height: 70%;
    }
    .banner-text h2 {
      font-size: 30px;
      white-space: break-spaces;
    }
    .banner-text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: break-spaces !important;
      /* height: 40%; */
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #ffff;
      text-align: center;
      /* text-shadow: 0 2px 10px #ffff; */
      padding: 18%;
      /* background: #00000087; */
      /* border-radius: 12px; */
      max-width: 60%;
      font-family: 'roboto-black';
      /* border: 1px solid; */
      border: 0.3px solid #ffffff5d;
      /* padding: 5%; */
      width: 85%;
      /* width: 85%; */
      /* width: 100%; */
      max-width: 360px;
      margin: 0 auto;
      /* display: flex; */
      justify-content: center;
      /* align-items: center; */
      /* min-height: 100vh; */
      padding: 16px;
      box-sizing: border-;
    }
    .banner-text p {
      font-size: 18px;
      color: white;
      margin-top: 10px;
      font-family: 'roboto-regular';
      line-height: 30px;
      text-overflow: ellipsis; /* Muestra puntos suspensivos */
      white-space: break-spaces;
    }
    .contenido-centrado img {
      width: 80px; /* Ajustá el tamaño según tu diseño */
      height: auto;
    }
    .banner-carousel {
      position: relative;
      overflow: hidden;
      width: 100%;
      height: 100vh;
      /* height: 100%; */
      margin-bottom: -65%;
    }
    button.prev,
    button.next {
      position: absolute;
      top: 35%;
      transform: translateY(-50%);
      background: rgba(0, 0, 0, 0.3);
      border: none;
      color: #fff;
      font-size: 1rem;
      padding: 8px 14px;
      border-radius: 50%;
      cursor: pointer;
      transition: background 0.3s;
      z-index: 5;
    }
  }
}
</style>
